import React from "react"
import { CloseButton } from "@mantine/core"

const MantineCloseButton = (props: any) => {
    const { onClick, className } = props
    return (
        <CloseButton onClick={onClick} className={className} />

    )
}
export default MantineCloseButton;